export default __webpack_public_path__ + "static/media/stripe.7fef9328.svg";